export type AnswerProgressStatus = 'producing' | 'interrupted' | 'expired';

/** Server recovery metadata is display state only, never a continuation,
 * approval, Stop handle or evidence that provider/tool effects settled. */
export function answerProgressStatus(metadata: unknown): AnswerProgressStatus | null {
  if (!metadata || typeof metadata !== 'object') return null;
  const meta = metadata as { answerProgress?: unknown; custom?: { answerProgress?: unknown } };
  const value = Object.hasOwn(meta, 'answerProgress')
    ? meta.answerProgress
    : meta.custom?.answerProgress;
  if (!value || typeof value !== 'object') return null;
  const { status, cursor } = value as { status?: unknown; cursor?: unknown };
  if (typeof cursor !== 'number' || !Number.isSafeInteger(cursor) || cursor < 0) return null;
  return status === 'producing' || status === 'interrupted' || status === 'expired' ? status : null;
}
